import { useEffect, useRef, useState } from "react";

/** Reveal-on-scroll wrapper using IntersectionObserver. */
export default function Reveal({ as: Tag = "div", delay = 0, className = "", children, ...rest }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          setTimeout(() => setShow(true), delay);
          obs.disconnect();
        }
      });
    }, { rootMargin: "-40px 0px", threshold: 0.05 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [delay]);

  return (
    <Tag ref={ref} className={`reveal ${show ? "in" : ""} ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
